import { ReferenceData } from './reference-data.model';

export class BusinessUnitAddress extends ReferenceData {

  line1: string;
  city: string;
  countyId: { correlation: string };
  stateId: { correlation: string };
  zipCode: string;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.line1 = data.line1;
    this.city = data.city;
    this.countyId = data.countyId;
    this.stateId = data.stateId;
    this.zipCode = data.zipCode;
  }
}
